<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->
    <!-- 模块1 -->

    <!-- 内容盒子 -->
    <div class="correction-content">
      <p>活动报名</p>
      <!-- 输入框 + 按钮 盒子 -->
      <div class="text-input">
        <el-form
          style="max-width: 343px"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="auto"
          class="demo-ruleForm"
          ref="formEl"
          label-position="top"
        >
          <el-form-item label="姓名:" prop="name" class="this-title">
            <el-input placeholder="请填写您的姓名" v-model="mydata.form.name" />
          </el-form-item>

          <el-form-item label="单位:" prop="school" class="this-title">
            <el-input
              placeholder="请填写您的单位"
              v-model="mydata.form.school"
            />
          </el-form-item>

          <el-form-item label="手机号码:" prop="tel">
            <el-input
              placeholder="请填写您的手机号"
              v-model="mydata.form.tel"
            />
          </el-form-item>

          <el-form-item label="邮箱:" prop="email" class="this-title">
            <el-input
              placeholder="请填写您的邮箱"
              v-model="mydata.form.email"
            />
          </el-form-item>

          <el-form-item label="教授学科:" prop="subject">
            <el-input
              placeholder="请填写您的教授学科"
              v-model="mydata.form.subject"
            />
          </el-form-item>

          <!-- <el-form-item label="教授学段:" prop="stage">
            <el-input v-model="mydata.form.stage" />
          </el-form-item> -->
          <el-form-item label="教授学段:" prop="stage" class="stage-b">
            <!-- <el-input
                v-model="mydata.form.gradeId"
                placeholder="请填你的年级"
              /> -->
            <el-select
              v-model="mydata.form.stage"
              placeholder="请选择您的教授学段"
            >
              <el-option
                v-for="item in mydata.study_stageOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="上传附件:" class="this-annex">
            <el-upload
              :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
              :auto-upload="true"
              :on-success="successFile1"
              list-type="picture-card"
              :on-change="uploadChange1"
              :on-remove="uploadRemove1"
              :on-preview="uploadPreview1"
              :class="{ hiddenUpload: mydata.hiddenUpload1 }"
              accept=".jpg,.jpeg,.png,.gif"
              :file-list="mydata.fileList1"
              :show-file-list="true"
            >
              <el-icon><Plus /></el-icon>
              <p class="upload-tip">点击上传图片</p>
            </el-upload>
            <el-dialog v-model="mydata.dialogVisible5">
              <img width="100%" v-complete:src="mydata.dialogImageUrl5" />
            </el-dialog>
          </el-form-item> -->
        </el-form>

        <!-- 提交按钮 -->
        <div class="box-button">
          <el-button
            v-if="mydata.isEnrolled === false"
            type="primary"
            @click="submitButton"
            style="width: 343px"
            >提交</el-button
          >
          <template v-else>
            <el-button
              type="primary"
              @click="submitButton1"
              v-if="mydata.isSubmitFileUrl === false"
              >立即上传</el-button
            >
            <el-button
              type="primary"
              @click="submitButton2"
              v-if="mydata.isSubmitFileUrl === false"
              >稍后上传</el-button
            >
            <el-button
              type="primary"
              @click="submitButton2"
              v-if="mydata.isSubmitFileUrl === true"
              style="width: 100% !important"
              >查看我的活动</el-button
            >
          </template>
        </div>
      </div>
    </div>
    <!-- 弹窗区域 -->
    <el-dialog v-model="mydata.dialogVisible" title="立即上传" width="343">
      <el-form
        ref="formEl2"
        :model="mydata.form2"
        :rules="mydata.rules2"
        label-width="100px"
      >
        <el-form-item label="上传附件" prop="file">
          <el-upload
            :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
            :auto-upload="false"
            :on-success="successFile1"
            :on-preview="uploadPreview1"
            :file-list="mydata.fileList1"
            :before-upload="beforeUpload"
            :show-file-list="true"
            :on-change="fileChange"
            :on-remove="fileRemove"
            :limit="1"
            :on-exceed="exceedFile"
          >
            <!-- :on-change="uploadChange1" -->
            <!-- :on-remove="uploadRemove1" -->
            <el-button type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submit">确认</el-button>
          <el-button @click="clickReaNameCancel">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "thisEventRegistrationTeacher",
});
</script>
<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";

// 引入接口
import {
  getTeacherActivities,
  activityFile,
} from "@/api/enterActivities/index.js";

//引入接口
import { get_grade_group } from "@/api/login/nowLogin/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  dialogVisible: false,
  form2: {
    file: [],
  },
  rules2: {
    file: [
      {
        required: true,
        message: "请上传附件",
      },
    ],
  },
  size: "default",

  study_stageOptions: [],
  form: {
    name: "",
    school: "",
    tel: "",
    email: "", //////无字段
    subject: "",
    stage: "",
    upload_photos: [],
  },

  rules: {
    name: [
      {
        required: true,
        message: "请填写您的姓名",
        trigger: "blur",
      },
    ],
    school: [
      {
        required: true,
        message: "请填写您的单位",
        trigger: "blur",
      },
    ],
    tel: [
      {
        required: true,
        message: "请填写您的手机号",
        trigger: "blur",
      },
    ],

    email: [
      {
        required: true,
        message: "请填写您的邮箱",
        trigger: "blur",
      },
    ],
    subject: [
      {
        required: true,
        message: "请填写您的教授学科",
        trigger: "blur",
      },
    ],
    stage: [
      {
        required: true,
        message: "请选择您的教授学段",
        trigger: "blur",
      },
    ],
  },
  btnLoading: false,

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  articleId: "", //文章id
  activityId: "", //
  xx: "/api/sale_auth/upload_file",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  hiddenUpload1: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],
  fiveM1: 1024 * 1024 * 5, // 单位字节B
  isEnrolled: false, // 是否已经提交过了
  isSubmitFileUrl: false,
});

const formEl = ref(null);
const formEl2 = ref(null);

mydata.articleId = route.query.id;
mydata.activityId = route.query.activityId;

mydata.isEnrolled = route.query.isEnrolled === "true";
mydata.isSubmitFileUrl = route.query.isSubmitFileUrl === "true";

//点击事件
function submitButton() {
  // router.push({
  //   path: "/layout/list/reviewQualificationsStep2",
  // });

  formEl.value.validate((valid, fields) => {
    if (valid) {
      // 调用教师加入活动
      getTeacherActivities(
        {
          article_id: mydata.articleId,
          ...mydata.form,
          files: mydata.form2.file.join(","),
        },
        mydata.userInfo.jwt
      ).then((res) => {
        // console.log("教师加入", res);
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        mydata.isEnrolled = true;
        mydata.activityId = res.data.id;
        // mydata.enterActivitiesList = res.data;
      });
    }
  });
}

function submitButton1() {
  // 打开弹窗
  mydata.dialogVisible = true;
}

function submitButton2() {
  router.push({
    path: "/layout/list/myActivity",
  });
}

// function handleClick(tab) {
//   console.log(tab);
// }

//按钮的事件函数
// function submit() {

// console.log(mydata.zhanghao, mydata.mima);
// mydata.btnLoading = true;
// axios({
//   method: "post",
//   url: "/house/login/login",
//   data: {
//     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
//     account: mydata.zhanghao,
//     password: mydata.mima,
//     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
//   },
// }).then((res) => {
//   mydata.btnLoading = false;
//   if (res.data.code === 1) {
//     ElMessage({
//       message: res.msg,
//       type: "success",
//     });

//     // 存储后端返回的token值
//     localStorage.setItem("token", res.data.data.token);
//     localStorage.setItem("adminName", mydata.zhanghao);

//     // 跳转页面
//     router.push({
//       path: "/layout/list/personalCenter/personalInfor/index.vue",
//     });

//     mydata.zhanghao = "";
//     mydata.mima = "";
//   }
// });
// }

// 文件改变事件
function uploadChange1(file, fileList) {
  // 赋值
  mydata.fileList1 = fileList;
  // 赋值
  mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;

  // 打印一下
  // console.log("我的数据", mydata.fileList1);

  formEl2.value.validateField("file");
}

// 文件移除事件
function uploadRemove1(file, fileList) {
  // 赋值
  mydata.fileList1 = fileList;
  // 赋值
  mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;
  // 赋值
  mydata.form2.file = fileList.map((item) => {
    return item.response.data.url;
  });
  formEl2.value.validateField("file");
}

// 文件预览事件
function uploadPreview1(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 赋值地址
  mydata.dialogImageUrl1 = file.url;
}

// 出版物许可证-文件上传成功
function successFile1(val) {
  mydata.form2.file.push(val.data.url);
  // console.log(mydata.form);
}

function beforeUpload(file) {
  const MAX_SIZE = 1024 * 1024 * 5; // 设定最大文件大小为5MB
  if (file.size > MAX_SIZE) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    return false; // 返回false停止上传
  }
  return true; // 返回true允许上传
}

// 实名认证
function clickReaNameCancel() {
  // 关闭弹窗
  mydata.dialogVisible = false;
}

function fileChange(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });
  formEl2.value.validateField("file");
}

function fileRemove(file, fileList) {
  mydata.form2.file = fileList.map((item) => {
    return item.raw;
  });
  formEl2.value.validateField("file");
}

function exceedFile() {
  // 提示弹窗
  ElMessage({
    message: "只可上传一个文件",
    type: "warning",
  });
}

//登录的事件函数
function submit() {
  // console.log(mydata.form2.file);

  formEl2.value.validate((v) => {
    if (v) {
      let formDataObj = new FormData();
      formDataObj.append("files", mydata.form2.file[0]);
      formDataObj.append("id", mydata.activityId);
      activityFile(
        // {
        //   id: mydata.activityId,
        //   files: mydata.form2.file,
        // },
        formDataObj,
        mydata.userInfo.jwt
      ).then((res) => {
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 关闭弹窗
        mydata.dialogVisible = false;
        mydata.isSubmitFileUrl = true;
        // 跳转页面
        // router.push({ path: "/layout/list/personalCenter/myActivity" });
      });
    }
  });
}

function init() {
  get_grade_group().then((res) => {
    mydata.study_stageOptions = res.data;
  });
  // get_grade().then((res) => {
  //   mydata.gradeIdOptions = res.data;
  // });
}

init();
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  // padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //内容盒子
  .correction-content {
    margin: 0 auto;
    padding: 16px;
    background-color: #ffffff;
    // box-shadow: 0px 5px 40px 0px #0000000d;
    border-radius: 8px;
    // border:1px solid blue;
    overflow: hidden;
    //活动报名
    > p {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
      text-shadow: 0px 2px 8px 0px #0000004d;
      background-color: #009de0;
      border-radius: 8px;
    }

    ////// 输入框 + 按钮 盒子  ////////////////////////////////////
    .text-input {
      // width: 422px;
      // height: 822px;
      margin: 0 auto;
      // border: 1px solid blue;
      margin-top: 20px;
      margin-bottom: 40px;
      overflow: hidden;

      :deep(.el-form-item) {
        // flex-direction: column;
        .el-input__wrapper {
          height: 40px;
        }
      }
      //下拉框
      :deep(.el-form-item.is-required.asterisk-left.stage-b) {
        // 字体
        .el-form-item__label-wrap {
          // border: 1px solid red;
          margin-left:0px !important;
        }
        // 下拉框高度
        .el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger {
          height: 40px;
        }
      }

      //输入框的长度（包括字体）
      :deep(.el-form-item.is-required.asterisk-left) {
        // width: 422px;
        margin-bottom: 20px;
        // height:32px;
        // border:1px solid blue;
        //字体
        .el-form-item__label {
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          // text-align: left;
        }
      }

      //上传附件（包括字体）
      :deep(.el-form-item.asterisk-left.this-annex) {
        //字体
        .el-form-item__label {
          // border:1px solid blue;
          // margin-left: -10px;
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
        }
      }

      //上传附件的输入框
      :deep(.el-button.el-button--default) {
        // border: 1px solid red;
        width: 422px;
      }
      //提示文字
      :deep(.el-button.submit-button > span) {
        // border: 1px solid red;
        width: 343px;
        text-align: left !important;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        letter-spacing: 1px;
        margin-left: -5px;
      }
      //上传附件的 文件名
      :deep(.el-upload-list.el-upload-list--text) {
        // border:1px solid red;
        // 文本图标
        .el-icon.el-icon--document {
          // color:red;
        }
        // 文字
        .el-upload-list__item-file-name {
          color: #009de0;
        }
      }

      ////// 按钮
      // :deep(.el-button.el-button--primary) {
      //   width: 422px;
      //   height: 40px;
      //   border-radius: 4px;
      //   margin-top: 40px;
      //   margin-bottom: 40px;

      //   > span {
      //     font-size: 14px;
      //     font-weight: 400;
      //   }
      // }
    }
  }
}

.box-button {
  display: flex;
  justify-content: space-between;
  // border:1px solid red;
  :deep(.el-button.el-button--primary) {
    width: 150px;
    height: 40px;
    border-radius: 4px;
    margin-top: 40px;
    // margin-bottom: 40px;

    // > span {
    //   font-size: 14px;
    //   font-weight: 400;
    // }
  }
}

:deep(.el-upload-list.el-upload-list--text) {
  // border:1px solid red;
  max-width: 240px;
}

//弹窗
:deep(.el-dialog) {
  border-radius: 0px;
}
</style>
